import { render, staticRenderFns } from "./TaksitDuzenleForm.vue?vue&type=template&id=1a129a24"
import script from "./TaksitDuzenleForm.vue?vue&type=script&lang=ts"
export * from "./TaksitDuzenleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports